import { render, staticRenderFns } from "./PackageForm.vue?vue&type=template&id=29e8203e&scoped=true"
import script from "./PackageForm.vue?vue&type=script&lang=js"
export * from "./PackageForm.vue?vue&type=script&lang=js"
import style0 from "./PackageForm.vue?vue&type=style&index=0&id=29e8203e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e8203e",
  null
  
)

export default component.exports